import { useSelector } from 'react-redux'

// Types
import type { State, EntityState, Distributor } from 'types'

const otherObj = {
  distributor_name: 'Other',
  distributor_note: '',
}

export const useDistributorList = (): Array<{ distributor_name: string; distributor_note: string }> => {
  const distributorList = useSelector<State, EntityState<Distributor>>((state: State) => state.entities.distributors)
  const distributorListSorted = Object.values(distributorList)
    .sort((a, b) => (a.distributor_name > b.distributor_name ? 1 : -1))
    .concat(otherObj)
  return distributorListSorted
}
